// 入力が半角スペース、全角スペースのみの場合は true を返す
export function isWhiteSpaceStr(str) {
  const regex = /^\s+$/;
  return regex.test(str);
}
// 入力が存在しない場合は true を返す
export function isEmptyStr(str) {
  const regex = /^$/;
  return regex.test(str);
}
